








































































































































































































































































































































































































































































import { Component, Vue, Inject, Prop, Watch } from "vue-property-decorator";
import Util from "@/lib/util";
import AbpBase from "@/lib/abpbase";
import PageRequest from "@/store/entities/page-request";
import EditTestQuestion from "./edit-testQuestion.vue";
import SisterQuestion from "./sister-Question.vue";
import ShowQuestionOfPapers from "./show-questionOfPapers.vue";

class PageTestQuestionRequest extends PageRequest {
  keyword: string;
  ExternalType: number = 0;
  classTypeId: number = 3;
  GradeType: number = 0;
  multiTypeName: string = "章节";
  parentId?: number;
  parentName: string = "上级分类";
  sectionId?: number;
  questionType: number = 0;
  ScreenType: number = 0;
  //isAudit: string = null;
  QuestionAuditFlow: string = null;
}

@Component({
  components: { EditTestQuestion, SisterQuestion, ShowQuestionOfPapers },
})
export default class TestQuestions extends AbpBase {
  pagerequest: PageTestQuestionRequest = new PageTestQuestionRequest();
  editModalShow: Boolean = false;
  sisterModalShow: Boolean = false;
  tesPaperModalShow: Boolean = false;
  loading: Boolean = false;
  multiTypes: any = [];
  data: any = [];
  showme: string = "测试";
  backshow: Boolean = false;
  selectedItems: any = [];
  valueArray: any = [];
  IsAuditList: any = [
    { value: "null", label: "全部" },
    { value: "1", label: "通过审核" },
    { value: "0", label: "未通过审核" },
    { value: "2", label: "申请修改" },
  ];
  IsUserList: any = [
    { value: 0, label: "全部试题" },
    { value: 1, label: "我的试题" },
  ];
  newtabdata: any = [
    { value: 0, label: "判断题", display: true },
    { value: 1, label: "单选题", display: true },
    { value: 2, label: "多选题", display: true },
    { value: 3, label: "填空题", display: true },
    { value: 4, label: "计算题", display: true },
    { value: 8, label: "解答题", display: true },
    { value: 9, label: "作文题", display: true },
    { value: 10, label: "探究题", display: true },
    { value: 11, label: "材料题", display: true },
    { value: 12, label: "实践题", display: true },
    { value: 7, label: "选考单选", display: true },
    { value: 5, label: "选考多选", display: true },
    { value: 6, label: "选考计算", display: true },
  ];

  mounted() {
    window.addEventListener("scroll", this.showbtn, true);
  }

  beforeDestroy() {
    window.removeEventListener("scroll", this.showbtn, true);
  }
  showbtn() {
    let scrollTop = (this.$refs["obtain"] as any).getBoundingClientRect().top;
    scrollTop < 210 ? (this.backshow = true) : (this.backshow = false);
  }
  backtop() {
    let _this = this;
    (_this.$refs["obtain"] as any).scrollIntoView(true);
    _this.backshow = false;
  }

  deletelistquestion() {
    if (!this.selectedItems.length) {
      this.$Message.warning({
        content: "未选中试题",
      });
      this.$Message.config({
        top: 50,
        duration: 2,
      });
    } else {
      let data = [];
      this.selectedItems.forEach((item) => {
        data.push({
          questionType: this.pagerequest.questionType,
          id: item.id,
        });
      });
      console.log(data);
      this.$store
        .dispatch({
          type: "testQuestion/deletelist",
          data: {
            deleteQuestions: data,
          },
        })
        .then((result) => {
          this.$Message.success({
            content: "删除成功",
          });
          this.$Message.config({
            top: 50,
            duration: 2,
          });
          this.getpage();
          this.backtop();
        });
    }
  }

  toTestPaper(id) {
    this.$store.state.testQuestion.editTestQuestion.id = id;
    this.tesPaperModalShow = true;
  }
  UsdegreeDifficulty(value) {
    if (value == 1) {
      return "(A层次)";
    } else if (value == 2) {
      return "(B层次)";
    } else {
      return "(C层次)";
    }
  }
  sisterQuestion(item) {
    this.$store.commit("testQuestion/sisterInfo", item);
    this.$store.state.testQuestion.sisterInfoTestQuestion.sisterId = item.id;
    this.sisterModalShow = true;
  }
  searchGetpage() {
    if (this.pagerequest.QuestionAuditFlow == "null") {
      this.pagerequest.QuestionAuditFlow = "";
    }
    this.$store.state.testQuestion.currentPage = 1;
    this.getpage();
  }
  async stateSwitching(id) {
    await this.$store.dispatch({
      type: "testQuestion/showStateSwitching",
      data: { id: id, questionType: this.pagerequest.questionType },
    });
    this.getpage();
  }
  async auditQuestion(id) {
    await this.$store.dispatch({
      type: "testQuestion/auditTestQuestionFlow",
      data: {
        id: id,
        questionAuditFlow: 1,
        questionType: this.pagerequest.questionType,
      },
    });
    this.getpage();
  }

  async resetupdate(id) {
    await this.$store.dispatch({
      type: "testQuestion/auditTestQuestionFlow",
      data: {
        id: id,
        questionAuditFlow: 2,
        questionType: this.pagerequest.questionType,
      },
    });
    this.getpage();
  }

  async doupdate(id) {
    await this.$store.dispatch({
      type: "testQuestion/auditTestQuestionFlow",
      data: {
        id: id,
        questionAuditFlow: 0,
        questionType: this.pagerequest.questionType,
      },
    });
    this.getpage();
  }

  async updateQuestion(row) {
    this.$store.commit("testQuestion/edit", row);
    this.editModalShow = true;
  }
  async deleteQuestion(id) {
    this.$Modal.confirm({
      title: "系统提示",
      content: "你确定要删除本试题？",
      okText: "是",
      cancelText: "否",
      onOk: async () => {
        await this.$store.dispatch({
          type: "testQuestion/delete",
          data: { id: id, questionType: this.pagerequest.questionType },
        });
        await this.getpage();
      },
    });
  }
  questionTypeChange(value) {
    this.pagerequest.questionType = value;
    this.$store.state.testQuestion.currentPage = 1;
    this.getpage();
  }

  cascaderSelect(value, selectedData) {
    this.selectedItems = [];
    if (value.length > 0) {
      this.newtabdata = [
        { value: 0, label: "判断题", display: true },
        { value: 1, label: "单选题", display: true },
        { value: 2, label: "多选题", display: true },
        { value: 3, label: "填空题", display: true },
        { value: 4, label: "计算题", display: true },
        { value: 8, label: "解答题", display: true },
        { value: 9, label: "作文题", display: true },
        { value: 10, label: "探究题", display: true },
        { value: 11, label: "材料题", display: true },
        { value: 12, label: "实践题", display: true },
        { value: 7, label: "选考单选", display: true },
        { value: 5, label: "选考多选", display: true },
        { value: 6, label: "选考计算", display: true },
      ];
      if (selectedData[0].id == 1033) {
        this.newtabdata[0].display = false;
      }
      if (
        selectedData[0].id == 1026 ||
        selectedData[0].id == 1027 ||
        selectedData[0].id == 1028 ||
        selectedData[0].id == 1029 ||
        selectedData[0].id == 1030 ||
        selectedData[0].id == 1031 ||
        selectedData[0].id == 1032 ||
        selectedData[0].id == 1033
      ) {
        this.newtabdata[2].display = false;
      }
      if (selectedData[0].id == 1031) {
        this.newtabdata[3].display = false;
      }
      if (
        selectedData[0].id == 1026 ||
        selectedData[0].id == 1028 ||
        selectedData[0].id == 1030 ||
        selectedData[0].id == 1031 ||
        selectedData[0].id == 1032 ||
        selectedData[0].id == 1033
      ) {
        this.newtabdata[4].display = false;
      }
      if (
        selectedData[0].id == 1027 ||
        selectedData[0].id == 1025 ||
        selectedData[0].id == 1029 ||
        selectedData[0].id == 1030 ||
        selectedData[0].id == 1031 ||
        selectedData[0].id == 1032 ||
        selectedData[0].id == 1033
      ) {
        this.newtabdata[6].display = false;
      }
      if (selectedData[0].id == 1028 || selectedData[0].id == 1033) {
        this.newtabdata[7].display = false;
      }
      if (
        selectedData[0].id == 1028 ||
        selectedData[0].id == 1025 ||
        selectedData[0].id == 1029 ||
        selectedData[0].id == 1030 ||
        selectedData[0].id == 1033
      ) {
        this.newtabdata[8].display = false;
      }
      if (
        selectedData[0].id == 1028 ||
        selectedData[0].id == 1025 ||
        selectedData[0].id == 1029 ||
        selectedData[0].id == 1030 ||
        selectedData[0].id == 1033
      ) {
        this.newtabdata[9].display = false;
      }

      if (
        selectedData[0].id == 1026 ||
        selectedData[0].id == 1027 ||
        selectedData[0].id == 1028 ||
        selectedData[0].id == 1029 ||
        selectedData[0].id == 1030 ||
        selectedData[0].id == 1031 ||
        selectedData[0].id == 1032 ||
        selectedData[0].id == 1033
      ) {
        this.newtabdata[10].display = false;
      }

      if (
        selectedData[0].id == 1026 ||
        selectedData[0].id == 1027 ||
        selectedData[0].id == 1028 ||
        selectedData[0].id == 1029 ||
        selectedData[0].id == 1030 ||
        selectedData[0].id == 1031 ||
        selectedData[0].id == 1032 ||
        selectedData[0].id == 1033
      ) {
        this.newtabdata[11].display = false;
      }

      if (
        selectedData[0].id == 1026 ||
        selectedData[0].id == 1027 ||
        selectedData[0].id == 1028 ||
        selectedData[0].id == 1029 ||
        selectedData[0].id == 1030 ||
        selectedData[0].id == 1031 ||
        selectedData[0].id == 1032 ||
        selectedData[0].id == 1033
      ) {
        this.newtabdata[12].display = false;
      }

      this.pagerequest.sectionId = selectedData[selectedData.length - 1].value;
      this.pagerequest.parentName = selectedData[selectedData.length - 1].label;
    } else {
      this.newtabdata = [
        { value: 0, label: "判断题", display: true },
        { value: 1, label: "单选题", display: true },
        { value: 2, label: "多选题", display: true },
        { value: 3, label: "填空题", display: true },
        { value: 4, label: "计算题", display: true },
        { value: 8, label: "解答题", display: true },
        { value: 9, label: "作文题", display: true },
        { value: 10, label: "探究题", display: true },
        { value: 11, label: "材料题", display: true },
        { value: 12, label: "实践题", display: true },
        { value: 7, label: "选考单选", display: true },
        { value: 5, label: "选考多选", display: true },
        { value: 6, label: "选考计算", display: true },
      ];
      this.pagerequest.sectionId = null;
    }
    this.getpage();
  }
  handleRefresh() {
    this.loadCascaders();
    this.getpage();
  }
  get list() {
    return this.$store.state.testQuestion.list;
  }
  get isAllChecked() {
    return this.selectedItems.length === this.list.length;
  }
  toggleAll(event) {
    if (event.target.checked) {
      this.selectedItems = this.list.slice();
    } else {
      this.selectedItems = [];
    }
  }

  //get loading() {
  //  return this.$store.state.testQuestion.loading;
  // }
  create() {
    this.editModalShow = true;
    this.$store.state.testQuestion.editTestQuestion.classTypeId = this.pagerequest.classTypeId;
    this.$store.state.testQuestion.editTestQuestion.multiTypeName = this.pagerequest.multiTypeName;
    this.$store.state.testQuestion.editTestQuestion.parentId = this.pagerequest.parentId;
    this.$store.state.testQuestion.editTestQuestion.parentName = this.pagerequest.parentName;
  }
  multiTypeChange() {}
  selectChange(item) {
    this.pagerequest.classTypeId = item.id;
    this.pagerequest.multiTypeName = item.text;
    this.valueArray = [];
    this.pagerequest.parentId = null;
    this.loadCascaders();
    this.searchGetpage();
  }

  pageChange(page: number) {
    this.$store.commit("testQuestion/setCurrentPage", page);
    this.getpage();
  }
  pagesizeChange(pagesize: number) {
    this.$store.commit("testQuestion/setPageSize", pagesize);
    this.getpage();
  }
  async loadCascaders() {
    let _this = this;
    _this.loading = true;
    await this.$store
      .dispatch({
        type: "testQuestion/getCascader",
        data: { classTypeId: this.pagerequest.classTypeId },
      })
      .then((result) => {
        this.data = this.$store.state.testQuestion.cascaders.items;
        if (sessionStorage.getItem("isGeneral") == "true") {
          if (this.data.length) {
            this.pagerequest.sectionId = this.data[0].value;
            this.pagerequest.parentName = this.data[0].label;
            this.valueArray.push(this.data[0].value);
          }
        }
        this.getpage();
      });
  }
  async getpage() {
    let _this = this;
    _this.selectedItems = [];
    if (!_this.loading) {
      _this.loading = true;
    }
    this.pagerequest.maxResultCount = this.pageSize;
    this.pagerequest.skipCount = (this.currentPage - 1) * this.pageSize;
    await this.$store
      .dispatch({
        type: "testQuestion/getAll",
        data: this.pagerequest,
      })
      .then((res) => {
        this.loading = false;
      })
      .catch((err) => {});
  }
  get isGeneral() {
    return sessionStorage.getItem("isGeneral") == "true" ? 1 : 0;
  }
  get userId() {
    return sessionStorage.getItem("userId");
  }

  get pageSize() {
    return this.$store.state.testQuestion.pageSize;
  }
  get totalCount() {
    return this.$store.state.testQuestion.totalCount;
  }
  get currentPage() {
    return this.$store.state.testQuestion.currentPage;
  }
  getTypeName(classTypeId) {
    for (var item of this.multiTypes) {
      if (item.id === classTypeId) return item.text;
    }
  }
  async created() {
    this.loadCascaders();
  }
}
